import { CloseIcon1, GenericInfoIcon, GetSportIcon } from 'assets/icons';
import ThreeDotsIcon from 'assets/images/ThreeDotsIcon.svg?react';
import cn from 'classnames';
import SystemBetGroupingPopup from 'features/coupon/component/SystemBetGroupingPopup';
import { getRedirectionPathFromBetslip } from 'features/coupon/utility';
import moment from 'moment';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import RenderConditionalLink from 'shared/components/ConditionalLink';
import useClickOutside from 'shared/hooks/useClickOutside';
import { PlaceBet } from 'shared/interface';

interface BetBuilderCardProps {
	className?: string;
	onClickRemoveGame?: (id: number) => void;
	getSelectedOutcomeName?: (item: any) => string;
	selectedOddsArray: any[];
	eventName: string;
	totalOdds?: number;
	date?: string;
	isBetSlip?: boolean;
	removeBet?: (id: string) => void;
	outcomeId?: string;
	couponType?: string;
	numOfItemsInBetslip?: number;
	handelSelectedBet?: (value: boolean, id: string) => void;
	banker?: boolean;
	selectedBet?: boolean;
	completedEvents?: string[];
	bet?: PlaceBet;
	warnings?: string[];
	changeGroup?: (outcomeId: string, newGroupIndex: number) => void;
	getSystemBetGroupName?: (outcomeId: string) => string;
	getNumOfGroups?: (outcomeId: string) => number;
	isCouponsPage?: boolean;
	showIcon?: number;
}

const BetBuilderCard = (props: BetBuilderCardProps) => {
	const {
		eventName,
		totalOdds,
		selectedOddsArray,
		outcomeId,
		date,
		isBetSlip,
		getSelectedOutcomeName,
		onClickRemoveGame,
		couponType,
		banker,
		selectedBet,
		completedEvents,
		bet,
		warnings,
		numOfItemsInBetslip = 0,
		removeBet = () => {},
		handelSelectedBet = () => {},
		changeGroup = () => {},
		getSystemBetGroupName = () => '',
		getNumOfGroups = () => 0,
		showIcon,
	} = props;

	const { t } = useTranslation();
	const [showGroupingDialog, setShowGroupingDialog] = useState(false);

	const dialogRef = useClickOutside(() => setShowGroupingDialog(false), 'click');

	const isEventCompleted = (outcomeId: string | undefined): boolean => {
		if (completedEvents && outcomeId) {
			return completedEvents.includes(outcomeId);
		} else return false;
	};

	const handleShowWarning = (outcomeId: string | undefined): boolean => {
		if (warnings && outcomeId) {
			return warnings.includes(outcomeId);
		} else return false;
	};

	// TO RESTORE IN THE FUTURE //

	// const betsInBetslip = bets.outcomes.find((betInBetslip: PlaceBet) => {
	//     return betInBetslip.eventName === eventName
	// })

	const renderBetslipActions = () => (
		<>
			{couponType === 'ako' && outcomeId && (
				<span className="close--icon pointer" onClick={() => removeBet(outcomeId)}>
					<CloseIcon1 className="width--7 height--7" />
				</span>
			)}
			{couponType === 'system' && (
				<span className="close--icon pointer" onClick={() => setShowGroupingDialog(true)}>
					<ThreeDotsIcon />
				</span>
			)}
		</>
	);

	const renderBetSelectionCheckbox = () => {
		const isAKO = couponType === 'ako';
		const isDisabled = isAKO ? numOfItemsInBetslip <= 1 && selectedBet !== false : numOfItemsInBetslip <= 2 && banker === false;
		const isChecked = isAKO ? selectedBet : banker;

		if (isAKO) {
			return (
				<label className="bet-checkbox custom-checkbox">
					<input
						disabled={isDisabled}
						type="checkbox"
						checked={isChecked}
						onChange={(e: any) => (outcomeId ? handelSelectedBet(e.target.checked, outcomeId) : null)}
					/>
					<span className="check-mark" />
				</label>
			);
		}
	};

	const redirectToEventPage = bet ? getRedirectionPathFromBetslip(bet) : '';

	return (
		<div
			className={cn('bet-builder-card', props.className, {
				'is-disabled': isEventCompleted(bet?.outcomeId?.toString()),
				// 'bet-builder-card--isBorderBottom': isCouponsPage,
			})}
			// ref={ref}
		>
			{!!date && <p className="font--regular pl--25 mt--0 mb--3">{moment(date).local().format('DD.MM.YYYY HH:mm').toString()}</p>}
			<div className="bet-builder-card-event">
				<GetSportIcon id={bet?.sportId ?? (showIcon as number)} className="sport--icon" />
				<p style={{ width: 'calc(100% - 40px)' }} className="bet-builder__event-name">
					{eventName}
				</p>
				{isBetSlip && renderBetslipActions()}
			</div>

			<RenderConditionalLink to={redirectToEventPage} linkCondition={!!isBetSlip}>
				<div className="card__detail-wrapper">
					{selectedOddsArray.map((item, index) => (
						<div className="card__detail" key={`selectedOddsArray-${index}`}>
							<div className={`card__body ${selectedOddsArray.length === 1 ? 'no--padding' : ''}`}>
								<p className="event-bet-option">{item.gameName}</p>
								<p className="event-bet-name">{getSelectedOutcomeName ? getSelectedOutcomeName(item) : item.name}</p>
							</div>
							{!isBetSlip && onClickRemoveGame && (
								<span className="close--icon pointer" onClick={() => onClickRemoveGame(item.outcomeId)}>
									<CloseIcon1 />
								</span>
							)}
							{totalOdds && index + 1 === selectedOddsArray.length && <span className="bet-odds">{totalOdds.toFixed(2)}</span>}
						</div>
					))}
				</div>
			</RenderConditionalLink>
			{isBetSlip && renderBetSelectionCheckbox()}

			{handleShowWarning(bet?.outcomeId.toString()) && !isEventCompleted(bet?.outcomeId.toString()) && (
				<div className="warning-section bet-builder-ver">
					<GenericInfoIcon className="warning--icon" />
					<p className="warning-p">{t('oddsEventChanged')}</p>
				</div>
			)}
			{isEventCompleted(bet?.outcomeId.toString()) && (
				<div className="warning-section warning-event-completed disabled">
					<p className="warning-p">{t('unAvailableBet')}</p>
					{/* <p className='font-size--12 no--margin line-height--17 font--bold'>{t('iBelieve')}</p> */}
				</div>
			)}

			{/* TO RESTORE IN THE FUTURE
            {betsInBetslip &&  <p style={ {'color': 'red'}}>{t('eventAdded')}</p>}
             */}

			{showGroupingDialog && (
				<SystemBetGroupingPopup
					showGroupingDialog={showGroupingDialog}
					setShowGroupingDialog={() => setShowGroupingDialog(false)}
					dialogRef={dialogRef}
					removeBet={removeBet}
					groupArray={bet?.outcomeId ? [...Array(Number(getNumOfGroups(bet.outcomeId)))] : [1]}
					outcomeId={bet?.outcomeId || ''}
					isBanker={bet?.banker}
					numOfItemsInBetslip={numOfItemsInBetslip}
					handleGroupChange={changeGroup}
					handleSelectedBet={handelSelectedBet}
					getSystemBetGroupName={getSystemBetGroupName}
				/>
			)}
		</div>
	);
};

export default BetBuilderCard;
